import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { ModularSubscriptionsElements, isSupportedProvider } from '../types';
import { subscriptionProviderElementsMap, paymentProviderElementsMap } from '../data';

export const usePaymentComponent = (): ModularSubscriptionsElements | null => {
    const subscriptionsProvider = useFeature('subscriptionsProvider')?.name;
    const stripeGateway = useFeature('stripe')?.enabled;

    if (stripeGateway) {
        return paymentProviderElementsMap.stripe;
    }

    if (subscriptionsProvider && !isSupportedProvider(subscriptionsProvider)) {
        return subscriptionProviderElementsMap[subscriptionsProvider];
    }

    return null;
};
